export const firebaseConfig = {
  apiKey: "AIzaSyB8ev71JcUZ7v2ioju09zGhUdcNM8GssD0",
  authDomain: "cloze-test.firebaseapp.com",
  databaseURL: "https://cloze-test.firebaseio.com",
  projectId: "cloze-test",
  storageBucket: "cloze-test.appspot.com",
  messagingSenderId: "793207384000",
  appId: "1:793207384000:web:9eed70a68c554764ddca25"
};